module.exports = __webpack_public_path__ + "img/open.1dc9dc7d.svg";